import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  ENTITY_MODAL_TITLE_MAP,
  ENTITY_TYPE_HREF_MAP,
  LOAN_AND_LOCK_SECTION_HREF_MAP,
} from '../../EditModal.constants';

import { titleStyles, titleWrapperStyles } from './AdditionalComponents.styles';
import LockInfoAdditionalInfo from './LockInfoAdditionalInfo';
import PropertyAdditionalInfo from './PropertyAdditionalInfo';

const Title = ({ subtab = null, section = null }) => {
  const title = ENTITY_MODAL_TITLE_MAP[subtab];

  return (
    <Box sx={titleWrapperStyles}>
      <Typography sx={titleStyles} variant="bold20">
        {title}
      </Typography>

      {subtab === ENTITY_TYPE_HREF_MAP.PROPERTY_INFO && <PropertyAdditionalInfo />}
      {subtab === ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK &&
        section === LOAN_AND_LOCK_SECTION_HREF_MAP.LOCK_INFO && <LockInfoAdditionalInfo />}
    </Box>
  );
};

Title.propTypes = {
  section: PropTypes.string,
  subtab: PropTypes.string,
};

export default Title;
